import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  hydrateConfirmationHistoryEntries,
  hydrateConfirmations,
  hydrateCustomers,
  hydrateDeals,
  hydrateSMSAgentMessages,
  hydrateUsers,
  hydrateVehiclesAndListingsFromIndexer,
} from '@/models/hydrate';
import { useEffect } from 'react';

const useMyDealsPageHydrateLatest = () => {
  const isMyDealsPageActive = isPageActive(PAGE_ROUTES.MY_DEALS);
  const shouldRun = isMyDealsPageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateMyDealsPage = async () => {
      // Dev note: This can be optimized by running this for only the deals above the fold
      // and for just my deals
      await Promise.all([
        hydrateDeals(),
        hydrateCustomers(),
        hydrateVehiclesAndListingsFromIndexer(),
        hydrateUsers(),
        hydrateSMSAgentMessages(),
      ]);

      await Promise.all([
        hydrateConfirmations(),
        hydrateConfirmationHistoryEntries(),
      ]);
    };

    hydrateMyDealsPage();
  }, [shouldRun]);
};

export default useMyDealsPageHydrateLatest;
